<template>
  <div class="introduction_body">
    <div>
      <el-row style="margin: 0px">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
          <div class="grid-content bg-purple"></div>
          <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
              <div class="grid-content bg-purple"></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 210px;
                    background-color: white;
                    height: 305px;
                    border-radius: 15px;
                    padding-top: 10px;
                  "
                >
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-vertical-demo"
                    @select="handleOpen"
                  >
                    <el-menu-item index="1">
                      <i class="el-icon-menu"></i>
                      <span slot="title">实验目的</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                      <i class="el-icon-film"></i>
                      <span slot="title">实验原理</span>
                    </el-menu-item>
                    <!-- <el-menu-item index="3">
                      <i class="el-icon-date"></i>
                      <span slot="title">实验流程</span>
                    </el-menu-item> -->
                    <el-menu-item index="4">
                      <i class="el-icon-monitor"></i>
                      <span slot="title"> 实验方法</span>
                    </el-menu-item>
                    <el-menu-item index="5">
                      <i class="el-icon-tickets"></i>
                      <span slot="title">实验教学过程</span>
                    </el-menu-item>
                    <el-menu-item index="6">
                      <i class="el-icon-tickets"></i>
                      <span slot="title">实验教学特色</span>
                    </el-menu-item>
                  </el-menu>
                </div>
              </div>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
              <div class="grid-content bg-purple-light"></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 1000px;
                "
              >
                <div class="content_text_body">
                  <div v-if="this.activeIndex === '1'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        实验目的
                      </div>
                      <!-- <el-button :type="buttonType1" @click="cutpage('1')"
                        >实验目的</el-button
                      >
                      <el-button :type="buttonType2" @click="cutpage('2')"
                        >总体设计</el-button
                      > -->
                    </div>
                    <div class="content_text_m">
                      <div class="knowledge_text" v-if="this.buttonType1">
                        1.掌握配位聚合的基本原理，能够根据产品的需要，对聚乙烯合成工艺参数进行调控；
                        <br />
                        2.掌握聚乙烯工艺流程，通过虚拟仿真系统熟练进行聚合、干燥、回收和造粒等工段的开停车操作，强化对学生工程实践能力和动手能力的培养；
                        <br />
                        3.掌握聚乙烯生产过程突发情况应急处理措施，培养学生应对突发情况处置能力及安全生产意识，提高工程素养。
                        <br />
                        4.掌握聚乙烯装置设备及仪表的基本结构，使学生具备多学科背景的知识并解决生产过程中出现的问题。
                      </div>
                      <!-- <div class="knowledge_text" v-if="this.buttonType2">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 1000px;
                          "
                        >
                          <img
                            src="../../assets/banner/123.png"
                            height="593"
                            width="724"
                          />
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '2'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        实验原理
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          width: 1000px;
                        "
                      >
                        <div class="knowledge_text">
                          <!-- 本虚拟仿真实验采用聚乙烯淤浆聚合工艺，在主催化剂TiCl4和助催化剂AlEt3作用下，己烷作为分散剂，乙烯、共聚单体1-丁烯和分子量调节剂氢气发生化学反应，形成聚乙烯粉末粒子，通过挤压造粒得到所需的聚合物产品。
                          <br />
                          <div style="text-align: center; margin-top: 20px">
                            <img src="../../assets/datum/1.png" width="500px" />
                            <br />
                            <span style="font-size: 14px">
                              乙烯聚合反应机理
                            </span>
                          </div> -->

                          <p>
                            Ziegler-Natta型催化剂的活性中心是元素周期表中第Ⅳ~Ⅷ族的过渡金属Ti、V、Cr、Ge等，其卤化物与第Ⅰ~Ⅳ族元素的烷基化合物、芳基化合物及氢化物等反应生成可以使乙烯在低压和较低温度下聚合的活性催化剂体系，其中最常用的过渡金属卤化物为TiCl4。
                          </p>
                          <p>
                            Ziegler-Natta型催化剂催化乙烯聚合反应的机理是使催化剂活性中心与乙烯分子进行配位络合，进而引发阴离子聚合反应。Ziegler-Natta型催化剂的活性中心也是过渡金属-碳键。催化剂表面的Ti离子，由于它的外层电子未满而能吸收乙烯的一对电子，从而产生极性而发生聚合。活性中心以硅胶或硅酸铝为载体。聚合反应可分为:链引发、链增长、链转移、链终止几个步骤。
                          </p>
                          ①链引发和链增长
                          <p style="text-indent: 2em">
                            Ziegler-Natta型催化剂的链引发和链增长反应是通过乙烯插入Ti-C键而引发聚合的。
                          </p>
                          <p style="text-align: center">
                            Ti-聚合物+CH2=CH2→M-CH2-CH2-聚合物
                          </p>
                          ②链转移
                          <p style="text-indent: 2em">
                            Ziegler-Natta型催化剂链转移反应方式有以下几种。
                          </p>
                          <p style="text-indent: 4em">a.向氢分子链转移:</p>

                          <p style="text-align: center">
                            cat-聚合物+H2→cat-H+H-聚合物
                          </p>
                          <p style="text-indent: 4em">b.向单体链转移:</p>
                          <p style="text-align: center">
                            cat-CH2-CH2-聚合物+C2H4→cat-C2H5+CH2=CH-聚合物
                          </p>
                          <p style="text-indent: 4em">c.分子链转移:</p>
                          <p style="text-align: center">
                            cat-CH2-CH2-聚合物→cat-H+CH2=CH-聚合物
                          </p>
                          <p style="text-indent: 4em">
                            d.向有机金属化合物链转移:
                          </p>
                          <p style="text-align: center">
                            cat-聚合物+Al(C2H5)3→cat-C2H5+(C2H5)2Al-聚合物
                          </p>
                          ③链终止
                          <p style="text-indent: 2em">
                            Ziegler-Natta型催化剂就其本身而言，是一种不存在链终止过程的催化剂。其活性中心应该是始终保持催化活性的，但是当反应系统中含有CO、CO2、O2、H2S、H2O等导致催化剂失去活性的杂质时，这些杂质会导致链终止反应发生。
                          </p>
                          <p style="text-indent: 2em">
                            利用Ziegler-Natta型催化剂这种特性，当需要强制聚合反应结束时可人为地向反应系统中加入使催化剂失去活性的终止剂。对Ziegler-Natta型催化剂使用的终止剂一般是CO，CO2，该终止剂具有高效性和可逆性的特点。
                          </p>

                          <p style="text-indent: 2em">
                            Ziegler-Natta型催化剂控制链转移反应的方法是改变反应温度、烷基金属化合物浓度和氢气浓度。升高反应温度，链转移反应加速，生产的聚合物分子量小；降低反应温度，链转移反应减慢，生产的聚合物分子量大。同样，提高烷基金属化合物浓度或氢气浓度，链转移反应加速;降低金属化合物浓度或氢气浓度，链转移反应速度减慢。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '3'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        实验流程
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          width: 1000px;
                        "
                      >
                        <!--<img src="../../assets/mindmapping/szdx.png" style="width: 95%;margin: 20px auto;">-->
                        <img
                          src="../../assets/banner/123.png"
                          style="width: 95%; margin: 20px auto"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '4'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        实验方法
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          width: 1000px;
                        "
                      >
                        <div class="knowledge_text">
                          <p style="text-indent: 2em">
                            本实验项目中，构建了“方案设计-流程模拟-虚拟仿真-在线考试”的实验教学过程，通过线上线下相结合，注重对学生解决复杂工程问题能力的培养并融入多学科背景知识，强化现代工程工具的使用，在整个实验过程中融入了项目式、案例式、研讨式和互动式的教学方法，通过团队合作，培养学生的团队合作精神。
                          </p>
                          <p style="text-indent: 2em">
                            实验教学过程中强化“以学生为中心、产出导向和持续改进”的教学理念，从单纯验证性向设计性和研究性教学模式的转变，由灌输式教学法向自主式教学法改变，正确处理在教学过程中“教”与“学”的关系，强化学生的主体地位。同时将思政元素有效融入到实验教学的全过程，注重学生创新能力的培养，实现育人与育才的高度统一。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '5'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        实验教学过程
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          width: 1000px;
                        "
                      >
                        <div class="knowledge_text">
                          <p style="text-indent: 2em">
                            本实验共8学时，实验过程中分为方案设计（1学时）、流程模拟（3学时）、虚拟仿真（3学时）与在线考试（1学时）四个部分，具体教学设计如下：
                          </p>
                          <p style="text-indent: 2em">
                            （1）方案设计：根据所学的高分子化学、高分子物理及高聚物合成工艺学的知识，以团队合作的形式设计一套聚乙烯生产工艺流程，并在设计过程中能够考虑到安全、环保及技术经济的影响，并能体现创新意识。在设计方案中，能够体现工艺参数如主催化剂、助催化剂、氢气、共聚单体1-丁烯、温度和压力对产品熔融指数和密度的影响并能够根据产品性能的要求（如注塑、挤出和吹塑），按照所设计的加工量确定工艺条件。
                          </p>
                          <p style="text-indent: 2em">
                            （2）流程模拟：根据设计方案，采用Aspen
                            Plus软件Polymer
                            Plus模块，确定模拟组分、各反应原料的规格、反应进料量及操作条件并建立聚合反应的流程模拟图，选取合理的动力学模型及动力学数据、在合理建模的基础上，对所设计的工艺流程进行优化，获取相关模拟数据，并与真实的生产数据对比，验证模型的正确性。
                          </p>
                          <p style="text-indent: 2em">
                            （3）虚拟仿真：虚拟仿真分为初阶、中阶和高阶三个层次，初阶层次学生通过自学对聚乙烯工艺知识、安全环保知识、设备及仪表基础知识进行学习，在3D场景下，完成对聚乙烯工艺的认知；中阶层次学生在教师的指导下，在2D场景下，完成对聚乙烯各工段的操作，同时掌握在应急条件下，各类事故的应急处理；高阶层次，根据产品性能的需要，对催化剂加入量、温度、共聚单体1-丁烯的量、氢气等工艺参数进行调整及优化。
                          </p>
                          <p style="text-indent: 2em">
                            （4）在线考试：通过虚拟仿真系统在线考试功能，掌握学生对聚乙烯工艺的掌握程度，评价学生的学习效果，明确将来持续改进的方向。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '6'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        实验教学特色
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          width: 1000px;
                        "
                      >
                        <div class="knowledge_text">
                          <p style="text-indent: 2em">
                            聚乙烯合成过程中存在原料易燃易爆、工艺流程长、设备体量大及实验综合性强等特点，在实验室实现这一过程难度很大。本虚拟仿真实验项目通过三维仿真技术，再现了聚乙烯工艺的真实场景，还原了从聚合、干燥、回收及造粒的全过程，展现了各类设备及仪表的工作原理，实验过程中注重知识传授、能力培养及素质提高的协同实施，最终实现育人与育才的双重目标。
                          </p>
                          <p style="text-indent: 2em">
                            在实验设计方面，体现了多学科交叉融合，将高分子化学、高聚物合成工艺学、聚合反应工程、化工原理和聚合设备及仪表等知识有效融入到仿真系统中，注重对学生应用多学科知识解决复杂工程问题能力的培养，同时将石油精神、抚油精神及雷锋精神等思政元素有效融入整个实验过程，注重学思结合、知行统一，增强学生勇于探索的创新精神。
                          </p>
                          <p style="text-indent: 2em">
                            在实验教学方法方面，体现了校企协同育人，企业专家深度参与实验全过程，将聚乙烯生产过程中具体的实际问题引入实验教学内容之中，综合运用项目式、合作式及探究式等教学方法，强化对学生团队合作精神的培养，构建真实的生产工艺场景、真实的DCS操作界面和真实工艺数据，通过实验加深对工艺过程的理解。
                          </p>
                          <p style="text-indent: 2em">
                            在评价体系方面，体现了综合能力的考核与评价，形成“设计方案、流程模拟、虚拟仿真、在线考试”四位一体的评价模式，设计方案注重方案的合理性及多学科知识运用能力和团队合作精神评价，将工程素养和创新精神作为重要的考评内容，形成实验实践类课程思政效果的评价方法；流程模拟注重现代工程工具使用的评价，强化对学生数字化能力的培养；虚拟仿真注重学生对装置认识程度及操作正确性评价，注重对学生“为什么干，怎么干，干得怎么样”的评价，能够有效掌握学生对装置的认知程度；实习考试注重与工艺相关的基础知识、应急处理及安全环保内容的培养，全方面评价学生的实验学习效果。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduction",
  data () {
    return {
      activeIndex: "1",
      buttonType1: "",
      buttonType2: "",
      buttonType3: "",
      buttonType4: "",
      buttonIndex: "",
    };
  },
  mounted () {
    this.cutpage("1");
    let num = localStorage.getItem("redirectNum");
    if (num !== "undefined") {
      this.activeIndex = num;
    } else {
      this.activeIndex = "1";
    }
  },
  methods: {
    cutpage (index) {
      this.buttonIndex = index;
      this.getbottontype();
    },
    getbottontype () {
      if (this.buttonIndex === "1") {
        this.buttonType1 = "primary";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "2") {
        this.buttonType1 = "";
        this.buttonType2 = "primary";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "3") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "primary";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "4") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "primary";
      }
    },
    handleOpen (key, keyPath) {
      this.activeIndex = key;
    },
  },
};
</script>

<style scoped>
.introduction_body {
  background: url('../../assets/banner/login.png');
}

.content_text_body {
  display: flex;
  background-color: white;
  height: auto;
  min-height: 625px;
  margin-bottom: 40px;
  border-radius: 15px;
  width: 100%;
  flex-direction: column;
}

.content_text_m {
  width: 100%;
}

.knowledge_text {
  font-size: 18px;
  width: 95%;
  margin: 20px auto;
  text-align: left;
  line-height: 30px;
  font-weight: 300;
  line-height: 40px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
